import React from 'react';
import TextBlockEditPanel from 'components/report-content/components/text-block/TextBlockEditPanel';
import TextBlock from 'components/report-content/components/text-block/TextBlock';
import { AbstractComponentBuilder, ComponentSettingsTextBlock } from '@report-content';

export default class TextBlockComponentBuilder extends AbstractComponentBuilder<ComponentSettingsTextBlock> {
    getComponent(editPanel?: any) {
        return (
            <TextBlock
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
                editPanel={editPanel}
                blockId={this.block.uid}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <TextBlockEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
